import React from 'react';
import { Box } from '@mui/material';

// タブパネルのコンポーネント
interface TabPanelProps {
  children?: React.ReactNode;
  index: string;
  value: string;
}

/**
 * タブパネルコンポーネント
 * 選択されたタブの内容を表示する
 */
const TabPanel: React.FC<TabPanelProps> = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`dashboard-tabpanel-${index}`}
      aria-labelledby={`dashboard-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
};

// この a11yProps 関数は現在使用されていませんが、念のため残しておきます。
export function a11yProps(index: string) { // number から string に変更
  return {
    id: `dashboard-tab-${index}`,
    'aria-controls': `dashboard-tabpanel-${index}`,
  };
}

export default TabPanel;